import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { modalActions } from 'store/modal'
import { setLocale } from 'store/locales'
import { authActions } from 'store/user'
import { returnAccessibility } from 'utils/accessibility'
import { VISUAL_ACCESSIBILITY_MODES_MAP } from 'utils/constants'
import { Modal, Drawer } from 'components/UIElements'
import NavBarContainer from '../NavBar'
import ErrorBox from '../ErrorBox'
import SessionTimeout from './SessionTimeout'

import './CoreLayout.scss'
import { ThemeContext } from '../../contexts/ThemeProvider'
import { DirectionContext, checkRTL } from '../../contexts/DirectionProvider'

const CoreLayout = props => {
  const {
    children,
    drawer,
    locales,
    location,
    modal,
    sessionTimeoutSeconds,
    study,
    closeModal,
  } = props

  const isLoginPage = location.pathname === '/login'
  const { isDarkTheme, toggleTheme } = useContext(ThemeContext)
  const { isRTL, toggleDirection } = useContext(DirectionContext)

  const { selectedLocale } = locales

  useEffect(() => {
    toggleDirection(checkRTL(selectedLocale))
  }, [selectedLocale])

  useEffect(() => {
    closeModal()
  }, [location.pathname, closeModal])

  useEffect(() => {
    const participantAccessibilty = returnAccessibility(study)
    if (
      participantAccessibilty?.visual === VISUAL_ACCESSIBILITY_MODES_MAP.black
    ) {
      toggleTheme(true)
    } else {
      toggleTheme(false)
    }
  }, [study])

  return (
    <div
      className={`layout-container${isDarkTheme ? ' dark' : ''}${isRTL ? ' is-rtl' : ''
        }`}>
      <Modal {...modal} />
      <Drawer {...drawer} />
      {location.pathname !== '/login' &&
        location.pathname !== '/consent' &&
        !location.pathname.includes('web-survey') &&
        !location.pathname.includes('change-password') &&
        !location.pathname.includes('forgot-password') ? (
        <NavBarContainer />
      ) : null}
      {!isLoginPage && sessionTimeoutSeconds > 0 && (
        <SessionTimeout {...props} />
      )}
      <div
        className={
          isLoginPage
            ? 'core-layout__viewport login'
            : 'core-layout__viewport non-login'
        }>
        <ErrorBox />
        {children}
      </div>
    </div>
  )
}

const mapStateToProps = ({ modal, drawer, strings, user, locales }) => ({
  modal,
  drawer,
  sessionTimeoutSeconds: user?.study?.session_timeout_seconds,
  strings,
  study: user?.study,
  locales,
  humiIsabellaDisabled:
    user?.study?.config?.is_rewardless_study &&
    user?.study?.config?.is_avatarless_study
})
const mapDispatchToProps = {
  onLogout: authActions.logout,
  openModal: modalProps => modalActions.openModal(modalProps),
  closeModal: modalActions.closeModal,
  setLocale
}

export default connect(mapStateToProps, mapDispatchToProps)(CoreLayout)

CoreLayout.propTypes = {
  children: PropTypes.node,
  drawer: PropTypes.object,
  locales: PropTypes.shape({ selectedLocale: PropTypes.string }),
  location: PropTypes.object,
  modal: PropTypes.object,
  onLogout: PropTypes.func,
  openModal: PropTypes.func,
  closeModal: PropTypes.func,
  sessionTimeoutSeconds: PropTypes.number,
  study: PropTypes.shape({
    config: PropTypes.shape()
  })
}
